import { CONTACT_ADDRESS, PRODUCT_NAME, PRODUCT_SLUG } from "@amtana/module";

// `{product}` in a catalogue line reads as the product's name (`@amtana/module`'s
// product-name.ts), and `translate` fills it in without the caller passing it.

export { CONTACT_ADDRESS, PRODUCT_NAME, PRODUCT_SLUG };

/** The fill-in every line may use without the caller passing it. */
export const PRODUCT_HOLE = "{product}";

/** `text` with every `{product}` read as the product's name: for words kept outside a catalogue. */
export const withProductName = (text: string): string => text.replaceAll(PRODUCT_HOLE, PRODUCT_NAME);
